import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../styles/legal.css';

const TermsOfService: React.FC = () => (
    <>
        <Helmet>
            <title>Terms of Service — WeaveWords</title>
            <meta name="description" content="WeaveWords terms of service — the rules and conditions for using our language learning app." />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://www.weavewords.org/terms/" />
        </Helmet>
        <div className="legal-page">
            <h1>Terms of Service</h1>
            <p className="legal-meta">Last updated: June 2025</p>

            <section className="legal-section">
                <h2>1. Acceptance of terms</h2>
                <p>
                    By accessing or using WeaveWords (<a href="https://weavewords.org" className="legal-link">weavewords.org</a>),
                    you agree to be bound by these Terms of Service. If you do not agree, please do not use the service.
                </p>
            </section>

            <section className="legal-section">
                <h2>2. Description of service</h2>
                <p>
                    WeaveWords is a language learning application that uses spaced repetition (SM-2 algorithm) to help
                    users build and retain vocabulary. The service is available on web, iOS, and Android.
                </p>
            </section>

            <section className="legal-section">
                <h2>3. User accounts</h2>
                <p>
                    You are responsible for maintaining the confidentiality of your account credentials and for all
                    activities that occur under your account. You must be at least 13 years old to create an account.
                    You agree to provide accurate and complete information when registering.
                </p>
            </section>

            <section className="legal-section">
                <h2>4. Acceptable use</h2>
                <p>You agree not to:</p>
                <ul>
                    <li>Use the service for any unlawful purpose</li>
                    <li>Upload content that infringes intellectual property rights</li>
                    <li>Attempt to reverse-engineer or scrape the service</li>
                    <li>Share your account credentials with others</li>
                    <li>Upload harmful, offensive, or misleading content to public collections</li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>5. Content ownership</h2>
                <p>
                    You retain ownership of vocabulary content you create. By making a collection public, you grant
                    WeaveWords a non-exclusive licence to display that content to other users. You can make your
                    collections private or delete them at any time.
                </p>
            </section>

            <section className="legal-section">
                <h2>6. Pro subscription</h2>
                <p>
                    Pro features are available via a paid subscription processed through RevenueCat Billing (web) or
                    through in-app purchase via Apple App Store or Google Play (mobile). Subscriptions auto-renew unless cancelled
                    before the renewal date. Refunds are subject to the payment provider's policies.
                </p>
            </section>

            <section className="legal-section">
                <h2>7. Disclaimers</h2>
                <p>
                    WeaveWords is provided "as is" without warranties of any kind. We do not guarantee uninterrupted
                    availability or that the service will be error-free. Language learning outcomes depend on your
                    individual effort and practice.
                </p>
            </section>

            <section className="legal-section">
                <h2>8. Limitation of liability</h2>
                <p>
                    To the fullest extent permitted by law, WeaveWords shall not be liable for indirect, incidental,
                    or consequential damages arising from your use of the service.
                </p>
            </section>

            <section className="legal-section">
                <h2>9. Changes to terms</h2>
                <p>
                    We may update these terms from time to time. Continued use of the service after changes constitutes
                    acceptance of the revised terms. We will notify registered users of material changes by email.
                </p>
            </section>

            <section className="legal-section legal-section--last">
                <h2>10. Contact</h2>
                <p>
                    For questions about these terms, contact us at{' '}
                    <a href="mailto:admin@weavewords.org" className="legal-link">
                        admin@weavewords.org
                    </a>.
                </p>
            </section>

            <p className="legal-footer">
                <Link to="/privacy">Privacy Policy</Link>
                {' · '}
                <Link to="/">Back to WeaveWords</Link>
            </p>
        </div>
    </>
);

export default TermsOfService;
